import DiagnosticsModule, {
  MetricNames,
  MetricTags,
  OperationNames,
} from '@modules/DiagnosticsModule';

let windowOpen = true;

/**
 * Records time from navigation start to the first successful workspace
 * setup of this page load. Only the first setup attempt counts: a later
 * success (Retry, refetch) would include time the agent spent acting.
 * Skipped when the tab is hidden, since background tabs throttle timers;
 * a tab hidden during load and visible at this moment still over-reports.
 */
export function recordAppReady(): void {
  if (!windowOpen) {
    return;
  }
  windowOpen = false;
  if (document.hidden) {
    return;
  }
  DiagnosticsModule.recordHistogram(
    MetricNames.LATENCY_DURATION,
    performance.now(),
    { [MetricTags.OPERATION_NAME]: OperationNames.APP_READY },
  );
}

/** Ends the app-ready window after the first setup attempt, success or not. */
export function closeAppReadyWindow(): void {
  windowOpen = false;
}

export function __resetAppReadyForTests(): void {
  windowOpen = true;
}
